export default require('./Timer').default
